import { genericGet } from "../../services/api.service";
import { EntityConfig } from "../..";

export const AccountConfigs: EntityConfig = [
  {
    id: 'id',
    label: 'Id',
    type: 'id',
    nonEditable: true
  },
  {
    id: 'name',
    label: 'Nome',
    type: 'text'
  },
  {
    id: 'email',
    label: 'Email',
    type: 'text'
  },
  {
    id: 'password',
    label: 'Password',
    type: 'text',
    hidden: true
  },
  {
    id: 'pinPicagem',
    label: 'Pin para picagem',
    type: 'text',
    nonEditable: true
  },
  {
    id: 'roles',
    label: 'Role',
    type: 'enum',
    filterable: true,
    options: {
      route: 'state',
      getter: () => genericGet('/utilizadores/options/roles'),
    }
  }
]